import styled from 'styled-components'

export const Modals = styled.div`
  width: auto;
`
